import { Card } from "@/components/ui/card";
import { ChevronRight } from "lucide-react";
import { Link } from "wouter";
import type { Category } from "@shared/schema";

interface CategoryCardProps {
  category: Category;
}

export function CategoryCard({ category }: CategoryCardProps) {
  return (
    <Link href={`/category/${category.slug}`}>
      <Card className="overflow-visible group cursor-pointer hover-elevate" data-testid={`card-category-${category.slug}`}>
        <div className="relative overflow-hidden rounded-t-md">
          {category.image && (
            <img
              src={category.image}
              alt={category.name}
              className="w-full aspect-video object-cover transition-transform duration-300 group-hover:scale-105"
              data-testid={`img-category-${category.slug}`}
            />
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <h3 className="font-semibold text-white text-lg" data-testid={`text-category-name-${category.slug}`}>
              {category.name}
            </h3>
          </div>
        </div>
        <div className="p-4 flex items-center justify-between gap-2">
          <p className="text-sm text-muted-foreground line-clamp-1">
            {category.description}
          </p>
          <ChevronRight className="w-4 h-4 text-muted-foreground flex-shrink-0 transition-transform group-hover:translate-x-1" />
        </div>
      </Card>
    </Link>
  );
}
